const ApiErrorMessages = [
  { key: 'Network Error', message: '通信エラーが発生しました。少し時間を置いて再実行してください。' },
  { key: 'Request failed with status code 401', message: 'NO_AUTHORIZATION' },
  { key: 'Request failed with status code 500', message: 'エラーが発生しました。繰り返し発生する場合はお問い合わせ下さい。' },
]

export default class ApiErrorParser {
  parse (error) {
    // APIからエラーメッセージもらってる場合はそれを使う
    if (error.response && error.response.data && error.response.data.errors) {
      return error.response.data.errors.map(e => e)
    }

    const message = (ApiErrorMessages.find(m => m.key === error.message) || error).message
    return [{ type: 'system', message }]
  }
}

export const apiErrorParser = new ApiErrorParser()



// WEBPACK FOOTER //
// ./src/libs/api-error-parser.js